import PropTypes from 'prop-types'
import "./basebutton.scss";


const BaseButton = ({
    variant = 'primary',
    type,
    onClick,
    disabled,
    'data-test': dataTest,
    children,
}) => {
    return (
        <button
            type={type}
            className={`base-button base-button--${variant}`}
            onClick={onClick}
            disabled={disabled}
            data-test={dataTest}
        >
            {children}
        </button>
    );
};

BaseButton.propTypes = {
    variant: PropTypes.oneOf(['primary', 'danger']),
    type: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    'data-test': PropTypes.string,
    children: PropTypes.node,
}

export default BaseButton;
